import { languageService } from "../../../Language/language.service"
export function tableColumnsGenerator (sectionSchema) {
    return sectionSchema.map(section=>{
        return {
            Header: languageService(section.labelValue),
            accessor:  section.id,
        }
    })
} 


// WEBPACK FOOTER //
// ./src/components/MaterialTypeListView/utils/tableColumnsGenerator.js